import { ScoreDetailBuilder } from "src/context/ScoreDetail/ScoreDetailBuilder";
import { Drilldown } from "src/context/ScoreDetail/useDrilldown";
import { useTranslation } from "react-i18next";
import { ScoreDetailChartBox } from "../../Chart";
import { ChartMode, ScoreDetailChartData } from "../../Chart/chart.types";

type ByAllHeadingsType = {
    scoreDetailBuilder: ScoreDetailBuilder;
    drilldownState: Drilldown;
    mode: ChartMode;
};
export const ByAllHeadings = (props: ByAllHeadingsType) => {
    const { t } = useTranslation();

    const { scoreDetailBuilder, drilldownState, mode } = props;
    const summary = scoreDetailBuilder.getByHeadings();

    const data: ScoreDetailChartData[] = summary.headings.flatMap((h) => {
        const value = h.score.value;
        if (value === null) return [];

        return [
            {
                title: h.title,
                score: h.score,
                action: () => {
                    drilldownState.drilldown({
                        id: h.id,
                        label: h.title,
                        type: "headings",
                    });
                },
            },
        ];
    });
    const total: ScoreDetailChartData = {
        title: t("glossary.scores.mainVariation"),
        score: summary.total,
    };

    return <ScoreDetailChartBox data={data} total={total} mode={mode} />;
};
